import { ITheme } from "../../utils/theme";

export const containerStyle = {
  background: (theme: ITheme) => theme.palette.common.white,
  paddingRight: 1,
  paddingLeft: 1,
}

export const noShiftsTextStyle = {
  mb: 1,
  textAlign: 'center',
  color: (theme: ITheme) => theme.palette.black
}

export const shiftCardWrapperStyle = (theme: ITheme) => ({
  p: 1,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  display: 'inline-block',
  width: '100%',
})

export const availableLabelStyle = {
  float: 'right',
  color: (theme: ITheme) => theme.palette.red.A700,
  fontWeight: 'bold',
  mb: 1,
  mt: 2,
  '&.available': {
    color: (theme: ITheme) => theme.palette.green[600],
  }
}

export const shiftCardLabelStyle = (theme: ITheme) => ({
  [theme.breakpoints.down('sm')]: {
    '& .MuiFormControlLabel-label': {
      position: 'relative',
      top: '10px',
    },
  }
})

export const alertButtonStyle = {
  color: (theme: ITheme) => theme.palette.warning.light,
  fontWeight: 'bold',
  float: 'right'
}

export const lastDeclaredContainerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 0.25,
  align: 'left',
  position: "relative",
  width: "100%",
  mt: 3,
  mb: 4,
  ml: 1
}

export const lastDeclaredStyle = {
  cursor: 'pointer',
  color: (theme: ITheme) => theme.palette.corporateBlue,
  mt: 0.6,
  fontSize: '1.2rem',
  fontWeight: 'bold'
}

export const lastDeclaredIconStyle = {
  cursor: 'pointer',
  color: (theme: ITheme) => theme.palette.corporateBlue,
  fontSize: '2.5rem'
}

export const lastDeclaredPopupContainerStyle = {
  position: 'relative',
  width: '100%',
  margin: 'auto'
}

export const lastDeclaredPopupContentStyle = {
  position: 'absolute',
  zIndex: '999',
  top: '-24px',
  width: '100%'
}

export const lastDeclaredPopupTextContentStyle = {
  color: (theme: ITheme) => theme.palette.corporateBlue,
  fontSize: '0.85rem',
}

export const lastDeclaredPopupNoDataStyle = {
  mt: 2,
  mb: 2,
  color: (theme: ITheme) => theme.palette.corporateBlue,
  flexGrow: 1,
  textAlign: "center",
  fontSize: '0.85rem',
  align: 'center'
}

export const lastDeclaredPopupFlex = {
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  display: 'inline-flex',
  flexDirection: 'row'
}